import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../baseClasses/BaseComponent';
import animator from '../../helpers/animator';

import './ABCScroller.scss';

/**
 * This component is used within <TaskCompletionStepPhotoGrid> for web (non-mobile)
 * uploads into the grid (when more than one photo exists under a completion step)
 */
export class ABCScroller extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentLetter: 'a',
    };
    this.animator = new animator();

    this.isElementInViewport = this.isElementInViewport.bind(this);
  }

  handleScroll() {
    this.handleFindVisible();
  }

  handleMapToViewport() {
    const { itemList, itemKey } = this.props;  
    let viewPortMapper = {};
    if (itemList) {
      itemList.forEach(item => {
        let value = item[itemKey];
        if (value) {
          value = value.toLowerCase();
          viewPortMapper[value[0]] = true;
        }
      });
    }
    this.setState({ viewPortMapper: viewPortMapper });

    const viewPort = document.getElementById(this.props.viewPort);
    if (viewPort) {
      viewPort.parentElement.removeEventListener('scroll', this.handleScroll);
      viewPort.parentElement.addEventListener('scroll', this.handleScroll);
    }
  }

  componentDidMount() {
    this.handleMapToViewport();
  }

  componentWillUnmount() {
  }

  isElementInViewport(viewPort, el) {
    if (viewPort) {
      const rect = el.getBoundingClientRect();
      const viewPortRect = viewPort.parentElement.getBoundingClientRect();
      return (
        rect.top >= viewPortRect.top &&
        rect.bottom <= viewPortRect.bottom
      );
    }
    else{
      return false;
    }
  }

  handleFindVisible() {
    const { itemList, itemKey, itemIdKey } = this.props;
    const viewPort = document.getElementById(this.props.viewPort);
    let firstVisible;
    let lastVisible;
    if (viewPort && itemList) {
      itemList.forEach(item => {
        const id = item[itemIdKey];
        const value = item[itemKey];
        if (value) {
          const el = document.getElementById(id);
          if (el && this.isElementInViewport(viewPort, el)) {
            if (!firstVisible) {
              let firstValue = value.toLowerCase();
              firstVisible = firstValue[0];
            }
            let lastValue = value.toLowerCase();
            lastVisible = lastValue[0];
          }
          else {
          }
        }
      });
      if (firstVisible) {
        this.setState({ firstVisible, lastVisible });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.itemList != this.props.itemList) {
      this.handleMapToViewport();
    }
    if (prevState.viewPortMapper != this.state.viewPortMapper) {
      this.handleFindVisible();
    }
  }

  scrollIntoView(element) {
    var rect = element.getBoundingClientRect();
    const viewPort = document.getElementById(this.props.viewPort);

    var parentRect = viewPort.getBoundingClientRect();
    let scroller = viewPort.parentElement;
    var scrollRect = scroller.getBoundingClientRect();
    const id = scroller.id;
    if (rect.top <= scrollRect.top) {
      let amountAlreadyScrolled = Math.abs(scrollRect.top - parentRect.top);
      let additionalScroll = scrollRect.top - rect.top;
      let scrollAmount = amountAlreadyScrolled - additionalScroll;
      const ani = this.animator.createPropertyAnimation(id, 250, {
        verticalScroll: {
          startVal: amountAlreadyScrolled,
          endVal: scrollAmount,
        },
      });
      this.animator.addAnimation(ani);
      this.animator.processAnimationQueue(() => {
        this.handleFindVisible();
      });
    } else if (rect.bottom >= scrollRect.bottom) {
      let amountAlreadyScrolled = Math.abs(scrollRect.top - parentRect.top);
      let additionalScroll = rect.bottom - scrollRect.bottom;
      let scrollAmount = amountAlreadyScrolled + additionalScroll + 20;
      const ani = this.animator.createPropertyAnimation(id, 250, {
        verticalScroll: {
          startVal: amountAlreadyScrolled,
          endVal: scrollAmount,
        },
      });
      this.animator.addAnimation(ani);
      this.animator.processAnimationQueue(() => {
        this.handleFindVisible();
      });
    }
  }

  handleOnClick(e) {
    e.stopPropagation();
    const letter = e.currentTarget.id;
    const viewPort = document.getElementById(this.props.viewPort);
    if (viewPort) {
      let firstItem;
      let lastItem;
      let bottomItem;
      this.props.itemList.forEach(item => {
        const value = item[this.props.itemKey];
        if (!firstItem && value && value.toLowerCase()[0] >= letter) {
          firstItem = item;
        }
        if (value.toLowerCase()[0] == letter) {
          lastItem = item;
        }
        bottomItem = item;
      });
      const whichItem = lastItem ? lastItem : firstItem ? firstItem : bottomItem;
      if (whichItem) {
        const id = whichItem[this.props.itemIdKey];
        if (id) {
          const el = document.getElementById(id);
          if (!this.isElementInViewport(viewPort, el)) {
            this.scrollIntoView(el);
          }
        }
      }
    }
  }

  handleRenderAlphabet() {
    const { firstVisible, lastVisible, viewPortMapper } = this.state;
    const alphabet = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
    const alphabetItems = alphabet.map(letter => {
      let selected = letter >= firstVisible && letter <= lastVisible;
      let hasEntries = viewPortMapper && viewPortMapper[letter];
      return <div id={letter} key={letter} className={'abc-letter' + (selected && hasEntries ? ' selected-has-entries' : selected ? ' selected' : hasEntries ? ' has-entries' : '')} onClick={e => this.handleOnClick(e)}>{letter}</div>;
    });
    return <div className="abc-scroller">
      {alphabetItems}
    </div>;
  }

  render() {
    const abcs = this.handleRenderAlphabet();

    return (
      <div className="abc-scroller-container">
        {abcs}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.new_users ? state.new_users.currentUser : null,
  };
};
export default connect(mapStateToProps)(ABCScroller);



// WEBPACK FOOTER //
// ./src/components/ABCScroller/index.js